/**
 * DashboardHeroCard - Weekly Curation with compact stats
 */

import React from 'react';
import { Flame, Users, Package, Play } from 'lucide-react';

interface DashboardHeroCardProps {
  userName: string;
  creatorsCount: number;
  productsCount: number;
  viralVideosCount: number;
}

function DashboardHeroCardInner({ userName, creatorsCount, productsCount, viralVideosCount }: DashboardHeroCardProps) {
  const stats = [
    { icon: Users, value: creatorsCount, label: 'criadores analisados esta semana' },
    { icon: Package, value: productsCount, label: 'produtos analisados esta semana' },
    { icon: Play, value: viralVideosCount, label: 'vídeos virais detectados' },
  ];

  return (
    <div className="h-full forja-card rounded-xl backdrop-blur-sm p-2.5 md:p-3.5 flex flex-col">
      <div className="flex items-center justify-between gap-2 mb-2.5">
        <div className="flex items-center gap-2">
          <Flame className="w-3.5 h-3.5 text-primary" />
          <div>
            <h2 className="text-xs md:text-sm font-bold text-foreground leading-tight">
              Curadoria da Forja
            </h2>
            <p className="text-[8px] md:text-[9px] text-muted-foreground leading-tight">
              Inteligência selecionada pela equipe da Forja nesta semana.
            </p>
          </div>
        </div>
        <span className="inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full bg-primary/5 border border-primary/10 shrink-0">
          <Flame className="w-2.5 h-2.5 text-primary/60" />
          <span className="text-[10px] text-muted-foreground">
            Olá, <span className="text-primary/80 font-medium">{userName}</span>
          </span>
        </span>
      </div>
      
      <div className="grid grid-cols-3 gap-1.5 flex-1">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="flex flex-col items-center justify-center gap-0.5 py-2 px-1 rounded-lg bg-secondary/50 border border-border/30"
          >
            <stat.icon className="w-3 h-3 text-muted-foreground" />
            <span className="text-base md:text-lg font-bold text-foreground leading-none">
              {stat.value}
            </span>
            <span className="text-[7px] md:text-[8px] text-muted-foreground text-center leading-tight">
              {stat.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

const DashboardHeroCard = React.memo(DashboardHeroCardInner);
export default DashboardHeroCard;
